import { Button } from '@/components/ui/button'
import { WorkspaceOverviewStep } from './workspaceSteps/workspace-overview-step'
import { Step } from '../../shared/types/riskWorkspace.types'
import { WorkspaceHazardsStep } from './workspaceSteps/workspace-hazards-step'
import { WorkspaceCapitalsStep } from './workspaceSteps/workspace-capitals-step'
import { WorkspaceContextualStep } from './workspaceSteps/workspace-contextual-step'
import { WorkspaceLiveStep } from './workspaceSteps/workspace-live-step'
import { WorkspaceAreasStep } from './workspaceSteps/workspace-areas-step'
import { WorkspaceReviewStep } from './workspaceSteps/workspace-review-step'

type WorkspaceStepSelectorProps = {
  nextStep: () => void
  prevStep: () => void
  currentStep: Step
}

type StepProps = {
  step: Step
}

const StepComponent = ({ step }: StepProps) => {
  switch (step) {
    case 'overview':
      return <WorkspaceOverviewStep />
    case 'hazards_and_scenarios':
      return <WorkspaceHazardsStep />
    case 'capitals':
      return <WorkspaceCapitalsStep />
    case 'contextual_layers':
      return <WorkspaceContextualStep />
    case 'live_layers':
      return <WorkspaceLiveStep />
    case 'areas':
      return <WorkspaceAreasStep />
    case 'review_and_save':
      return <WorkspaceReviewStep />
  }
}

export const WorkspaceStepSelector = ({
  nextStep,
  prevStep,
  currentStep,
}: WorkspaceStepSelectorProps) => {
  return (
    <div className="flex flex-col p-8 items-center justify-between h-[calc(100vh-64px)] w-full bg-neutral-50">
      <div className="max-w-[992px] w-full">
        <StepComponent step={currentStep} />
      </div>
      <div className="flex justify-end max-w-[992px] w-full gap-2.5">
        <Button disabled={currentStep === 'overview'} variant="outline" onClick={prevStep}>
          Back
        </Button>
        <Button disabled={currentStep === 'review_and_save'} onClick={nextStep}>
          Next
        </Button>
      </div>
    </div>
  )
}
